module.exports = __webpack_public_path__ + "img/2ff752d.png";